import moment from "moment";

export function UTCNowUtil() {
  return new Date(Date.now());
}

export function UTCToOneMinuteAheadUtil() {
  return new Date(Date.now() + 60000);
}

export function UTCFromTimeFrameUtil(timeFrame: number) {
  if(!timeFrame)
  {
    timeFrame = 5;
  }
  return new Date(Date.now() - timeFrame * 60000);
}

export function ElapsedTimeUtil(startDate: string | Date): string {
  if (!startDate) {
    return "";
  }
  const startTime = new Date(startDate);
  const endTime = new Date(Date.now());
  let totalSeconds = (Number(endTime) - Number(startTime)) / 1000;

  let hours: number | string = Math.floor(totalSeconds / 3600);
  if (hours < 10) {
    hours = "0" + hours;
  }
  let minutes: number | string = Math.floor((totalSeconds % 3600) / 60);
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  let seconds: number | string = Math.floor((totalSeconds % 3600) % 60);
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  return [hours, minutes, seconds].join(":");
}

export function FinalElapsedTimeUtil(startDate: string | Date, endDate: string | Date) {
  if (!startDate) {
    return "";
  }
  const startTime = new Date(startDate);
  const endTime = new Date(endDate);
  let totalSeconds = (Number(endTime) - Number(startTime)) / 1000;

  let hours: number | string = Math.floor(totalSeconds / 3600);
  if (hours < 10) {
    hours = "0" + hours;
  }
  let minutes: number | string = Math.floor((totalSeconds % 3600) / 60);
  if (minutes < 10) {
    minutes = "0" + minutes;
  }
  let seconds: number | string = Math.floor((totalSeconds % 3600) % 60);
  if (seconds < 10) {
    seconds = "0" + seconds;
  }

  return [hours, minutes, seconds].join(":");
}

export const IsTimePlannedValidUtil = (fromTime: string | Date | undefined, toTime: string | Date | undefined) => {
  if(fromTime && fromTime !== "" && toTime && toTime !== ""){
    return moment(fromTime).isBefore(toTime);
  }
  else {
    return false;
  }
}

export const EpochMilliStringToSecondsUtil = (awsEpochDate: string | Date) => {
  return +awsEpochDate/1000;
}

export const isTimestampString = (value: string): boolean => {
  // Check if the string is purely numeric
  return /^\d+$/.test(value);

  // Optional implementation with sanity check: timestamps should be > 0 and reasonable
  // if(!/^\d+$/.test(value)) return false;
  // const num = Number(value);   
  // return num > 0 && num < 99999999999999; // ~year 5138
}

export const isDateString = (value: string): boolean  => {
  // Reject numeric-only strings (those are timestamps)
  if (/^\d+$/.test(value)) return false;

  const date = new Date(value);
  return !isNaN(date.getTime());
}